<template>
  <v-container>
   <v-card>
    <v-tabs
      v-model="tab"
      background-color="red lighten-2"
      dark
    >
      <v-tab
        v-for="n in length"
        :key="n"
      >
        Version {{ n }}
      </v-tab>
    </v-tabs>
    <v-card-text class="text-center">
      <!-- <v-btn text @click="length--">Remove Tab</v-btn> -->
      
      <v-btn color="primary" text disabled>Total Mark for this Question: {{ totalScore() }}</v-btn>
      <v-divider class="mx-4" vertical></v-divider> 
      <v-btn text @click="length++">Add Version</v-btn>
      <v-divider class="mx-4" vertical></v-divider>
       <v-btn color="error" v-on:click="sumbitForm">Delete this question</v-btn>
      <v-divider class="mx-4" vertical></v-divider>
      <v-btn color="success" v-on:click="sumbitForm">Save this question</v-btn>
      
    </v-card-text>

      <v-card-text class="text-center">
        <div class="text-center d-flex pb-4">
          <v-btn color="primary" @click="all">Show all</v-btn>
          <!-- <div>{{ panel }}</div> -->
          <v-divider class="mx-4" vertical></v-divider> 
          <v-btn color="primary" @click="none">Collapse All</v-btn>
          
        </div>

        <v-expansion-panels v-model="panel" multiple>
          <v-expansion-panel v-for="(item,i) in items" :key="i">
            <v-expansion-panel-header>Part {{ item }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="10">
                  <v-textarea
                    outlined
                    name="input-7-4"
                    label="Question"
                    value=""
                    type="number"
                    v-model="questions[i].text"
                  ></v-textarea>

                  <div v-if="questions[i].type != 'SQ'">
                    <v-text-field
                      label="Choice A"
                      placeholder="Placeholder"
                      v-model="questions[i].optionA"
                    ></v-text-field>
                    <v-text-field
                      label="Choice B"
                      placeholder="Placeholder"
                      v-model="questions[i].optionB"
                    ></v-text-field>
                    <v-text-field
                      label="Choice C"
                      placeholder="Placeholder"
                      v-model="questions[i].optionC"
                    ></v-text-field>
                    <v-text-field
                      label="Choice D"
                      placeholder="Placeholder"
                      v-model="questions[i].optionD"
                    ></v-text-field>
                  </div>

                  <!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. -->
                </v-col>

                <v-col cols="2">
                  <v-text-field label="Part Mark" placeholder="0" v-model="questions[i].score"></v-text-field>

                  <v-select
                    :items="question_types"
                    filled
                    label="Filled style"
                    v-model="questions[i].type"
                  ></v-select>

                  <div class="my-2">
                    <v-btn color="error" v-on:click="deleteThis(i)">Delete This Part</v-btn>
                  </div>
                  <div class="my-1">
                    <v-btn v-if="i != 0" color="success" v-on:click="up(i)"><v-icon>mdi-arrow-up-drop-circle</v-icon></v-btn>
                    <v-btn v-if="i != items - 1" color="success" v-on:click="down(i)"><v-icon>mdi-arrow-down-drop-circle</v-icon></v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="4">
          <v-btn color="error" v-on:click="sumbitForm">Delete this version</v-btn>
        </v-col>
        <v-spacer></v-spacer>

        <v-col cols="4">
          <div class="text-center">
            <v-menu open-on-hover top offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark v-on="on">New part for this version</v-btn>
              </template>

              <v-list>
                <v-list-item
                  v-for="(item, index) in question_types"
                  :key="index"
                  @click="newQuestion(item.value)"
                >
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-col>
       
        
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "NewQuestion",

  data: () => ({
    panel: [],
    items: 0,
    questions: [
      // { type: "SQ", score: 0, text: "dummy1", },
      // { type: "MC", score: 0, text: "dummy2", optionA: "AA", optionB: "B", optionC: "C", optionD: "D" },
      // { type: "SQ", score: 0, text: "dummy3" },
    ],
    question_types: [
      { text: "Multple Choices", value: "MC" },
      { text: "[TextBox] Multiple Choices", value: "MCTB" },
      { text: "Short Question", value: "SQ" }
    ],
    length: 1,
    tab: null,
  }),

  methods: {
    // Create an array the length of our items
    // with all values as true
    all() {
      this.panel = [...Array(this.items).keys()].map((k, i) => i);
    },
    // Reset the panel
    none() {
      this.panel = [];
    },
    deleteThis(i) {
      // console.log("here");
      // alert(JSON.stringify(this.questions));
      this.questions.splice(i, 1);
      this.items--;
    },
    newQuestion(option) {
      if (option) {
        this.questions.push({});
        this.questions[this.items].type = option;
        this.questions[this.items].score = 0;
        this.panel.push(this.items);
        this.items++;
      }
    },
    // questionTypeChanged(i) {
    //   this.questions[i].type = ""
    // },
    totalScore() {
      var totalScore = 0;

      for (var i = 0; i < this.items; i++) {
        totalScore += Number(this.questions[i].score);
      }

      return totalScore;
    },
    up(i) {
      [this.questions[i], this.questions[i - 1]] = [
        this.questions[i - 1],
        this.questions[i]
      ];
      this.all();
    },
    down(i) {
      [this.questions[i], this.questions[i + 1]] = [
        this.questions[i + 1],
        this.questions[i]
      ];
      this.all();
    },
    async sumbitForm() {
      var response = await fetch(
        process.env.VUE_APP_BASE_URL + "/question/create/",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({ questions: this.questions })
        }
      );

      var html = await response.text();
      alert(html);
    }
  },

  async mounted() {
    this.all();
  },

  watch: {
      length (val) {
        this.tab = val - 1
      },
    },
};
</script>